

const FontAwesomeIcon = ({iconName, isButton, isMenu}: any) => {
    return (
        <i className={iconName} style={{fontSize: isButton ? 13 : 16, marginRight: isMenu ? 8 : 0}}></i>
    )
};

export default FontAwesomeIcon;
